import React from 'react';

const Facebook = () => {
	return (
	<svg
		x="0px" y="0px"
		width="24"
		height="24"
		viewBox="0 0 612 612"
	>
		<g>
			<path d="M612,306C612,137.004,474.995,0,306,0C137.004,0,0,137.004,0,306c0,168.995,137.004,306,306,306
				C474.995,612,612,474.995,612,306z M223.825,306v-58.557h35.885V212.03c0-47.764,14.271-82.175,66.569-82.175h62.201v58.418
				h-43.785c-21.949,0-26.929,14.577-26.929,29.849v29.32h67.487L376.046,306h-58.278v176.617H259.71V306H223.825z"/>
		</g>
	</svg>
	)
}

export default Facebook;



// WEBPACK FOOTER //
// ./src/components/MainHeader/Facebook.js